/**
 * @fileoverview
 * Dropdown Service - Manages dropdown state
 * Migrated to core services
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Injectable } from '@angular/core';

export interface DropdownComponentRef {
  closeDropdown(): void;
}

@Injectable({
  providedIn: 'root',
})
export class DropdownService {
  private openDropdown: DropdownComponentRef | null = null;

  setOpenDropdown(dropdown: DropdownComponentRef | null) {
    if (this.openDropdown && this.openDropdown !== dropdown) {
      this.openDropdown.closeDropdown();
    }
    this.openDropdown = dropdown;
  }

  closeAllDropdowns() {
    // Early return if no dropdown is open - avoid unnecessary work
    if (!this.openDropdown) {
      return;
    }
    const dropdown = this.openDropdown;
    this.openDropdown = null; // Clear reference first to prevent re-entry
    dropdown.closeDropdown();
  }
}
